export default __webpack_public_path__ + "static/media/treasurehunt.5bbba57d.png";